import moment from "moment-timezone";

export function UTCDate__IsValid(isoDate: string) {
  return moment(isoDate).isValid();
}
